// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Photos-bannerContainer-V087T {
	position: relative;
	width: 100%;
	height: 500px;
	-webkit-transition: height .2s;
	transition: height .2s;
	cursor: pointer;
	border-radius: 12px;
}

.Photos-bannerImage-H4Sw8 {
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
	background-color: var(--primary-border);
	height: 500px;
	border-radius: 12px;
}

.Photos-viewPhotosBtn-dOlNh,
.Photos-viewPhotosBtn-dOlNh:hover,
.Photos-viewPhotosBtn-dOlNh:active,
.Photos-viewPhotosBtn-dOlNh:focus {
	bottom: 20px;
	right: 30px;
	position: absolute;
	border-radius: 6px;
	-webkit-box-shadow: none;
	        box-shadow: none;
	border: none !important;
	background-color: var(--primary-white-bg) !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 8px 12px;
}

.Photos-singleImage-Mo5N4 {
	height: 500px;
	border-radius: 12px;
}

.Photos-photoImage-Ph5Tw {
	width: 100%;
	max-width: 19px;
}

.Photos-gridPadding-mFXA2 {
	display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/Photos/Photos.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,8BAAsB;CAAtB,sBAAsB;CACtB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,uCAAuC;CACvC,aAAa;CACb,mBAAmB;AACpB;;AAEA;;;;CAIC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,wBAAgB;SAAhB,gBAAgB;CAChB,uBAAuB;CACvB,oDAAoD;CACpD,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;AACf","sourcesContent":[".bannerContainer {\n\tposition: relative;\n\twidth: 100%;\n\theight: 500px;\n\ttransition: height .2s;\n\tcursor: pointer;\n\tborder-radius: 12px;\n}\n\n.bannerImage {\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\tbackground-color: var(--primary-border);\n\theight: 500px;\n\tborder-radius: 12px;\n}\n\n.viewPhotosBtn,\n.viewPhotosBtn:hover,\n.viewPhotosBtn:active,\n.viewPhotosBtn:focus {\n\tbottom: 20px;\n\tright: 30px;\n\tposition: absolute;\n\tborder-radius: 6px;\n\tbox-shadow: none;\n\tborder: none !important;\n\tbackground-color: var(--primary-white-bg) !important;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 8px 12px;\n}\n\n.singleImage {\n\theight: 500px;\n\tborder-radius: 12px;\n}\n\n.photoImage {\n\twidth: 100%;\n\tmax-width: 19px;\n}\n\n.gridPadding {\n\tdisplay: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerContainer": `Photos-bannerContainer-V087T`,
	"bannerImage": `Photos-bannerImage-H4Sw8`,
	"viewPhotosBtn": `Photos-viewPhotosBtn-dOlNh`,
	"singleImage": `Photos-singleImage-Mo5N4`,
	"photoImage": `Photos-photoImage-Ph5Tw`,
	"gridPadding": `Photos-gridPadding-mFXA2`
};
module.exports = ___CSS_LOADER_EXPORT___;
